module.exports = __webpack_public_path__ + "static/media/nielit.6d6ff81c.png";